export default __webpack_public_path__ + "/images/night-sky.jpg";